import React from "react";
import { Tabs } from "@ann/web-components";
import { TabsContainer } from "./Tabs.styled";
import { FactDetailTabsEnum } from "../../enums/factDetailTabs";

const FactDetailTabs = ({ onTabChange, defaultIndex = FactDetailTabsEnum.OVERVIEW }) => {
  const handleTabChange = (index) => {
    if (onTabChange) {
      onTabChange(index);
    }
  };

  return (
    <TabsContainer>
      <Tabs defaultIndex={defaultIndex} size="medium" onChange={handleTabChange}>
        <Tabs.List>
          <Tabs.Tab index={FactDetailTabsEnum.OVERVIEW}>
            Overview
          </Tabs.Tab>
          <Tabs.Tab index={FactDetailTabsEnum.SUGGESTIONS}>
            Suggestions
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
    </TabsContainer>
  );
};

export default FactDetailTabs;

